/* Nested navigation
 *
 * Ghost Admin's navigation editor is a flat list of label/URL pairs, and there
 * is no supported way to add a tree widget to it. So the tree is encoded in the
 * label: an item whose label starts with "- " becomes a child of the nearest
 * item above it that has no prefix.
 *
 *     Documents          /documents/     <- parent
 *     - Bylaws           /bylaws/        <- child
 *     - Meeting Minutes  /minutes/       <- child
 *     Events             /events/
 *
 * It indents visibly in the admin list, so the menu shape is readable in the
 * editor itself. A parent that is not a real page can use "#" as its URL.
 *
 * This runs BEFORE dropdown() in main.js. dropdown() caches nav.innerHTML at
 * init and restores it on every resize; anything done after it is silently
 * wiped the first time the window changes size. See GOTCHAS.md #4.
 *
 * Declared as a top-level function so hoisting makes it available to main.js,
 * which gulp concatenates ahead of this file (assets/js/*.js, alphabetical).
 */
function nestedNav() {
    var CHILD = /^[-–—]\s+/; // "- ", plus en/em dash for a stray paste

    var head = document.querySelector('.gh-navigation');
    var nav = head && head.querySelector('.gh-navigation-menu .nav');
    if (!nav) return;

    // One select rather than a toggle plus a trigger: Ghost caps a theme at 20
    // custom settings and Source already ships 19. "Off"/"Hover"/"Click".
    // Markers are stripped even when the feature is off, so turning it off in
    // Admin gives a clean flat menu rather than a menu full of dashes.
    var mode = head.getAttribute('data-nested-nav') || 'Hover';
    var enabled = mode !== 'Off';
    var onClick = mode === 'Click';

    var parent = null;
    var n = 0;

    Array.prototype.slice.call(nav.children).forEach(function (item) {
        var link = item.querySelector('a');
        if (!link) return;

        var text = link.textContent.trim();
        if (!CHILD.test(text)) {
            parent = item;
            return;
        }

        link.textContent = text.replace(CHILD, '');

        // An orphan child (prefixed item with nothing above it) stays put
        // rather than vanishing.
        if (!enabled || !parent) return;

        var submenu = parent.querySelector(':scope > .gh-submenu');
        if (!submenu) {
            n += 1;
            submenu = document.createElement('ul');
            submenu.className = 'gh-submenu';
            submenu.id = 'gh-submenu-' + n;

            var toggle = document.createElement('button');
            toggle.className = 'gh-submenu-toggle';
            toggle.type = 'button';
            toggle.setAttribute('aria-expanded', 'false');
            toggle.setAttribute('aria-controls', submenu.id);
            toggle.setAttribute('aria-label', parent.querySelector('a').textContent.trim() + ' submenu');
            toggle.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="6 9 12 15 18 9"></polyline></svg>';

            parent.classList.add('has-submenu');
            parent.appendChild(toggle);
            parent.appendChild(submenu);
        }

        submenu.appendChild(item);
    });

    if (!enabled) return;

    var parents = nav.querySelectorAll('.has-submenu');
    if (!parents.length) return;

    head.classList.add('has-nested-nav');
    if (onClick) head.classList.add('is-nested-click');

    var closeAll = function (except) {
        Array.prototype.forEach.call(parents, function (p) {
            if (p === except) return;
            p.classList.remove('is-submenu-open');
            var t = p.querySelector(':scope > .gh-submenu-toggle');
            if (t) t.setAttribute('aria-expanded', 'false');
        });
    };

    Array.prototype.forEach.call(parents, function (p) {
        var toggle = p.querySelector(':scope > .gh-submenu-toggle');
        if (!toggle) return;

        // The caret is always clickable, on every breakpoint. Hover mode is
        // pure CSS on top of this, so keyboard and touch always have a way in.
        toggle.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            var open = p.classList.contains('is-submenu-open');
            closeAll(p);
            p.classList.toggle('is-submenu-open', !open);
            toggle.setAttribute('aria-expanded', open ? 'false' : 'true');
        });
    });

    document.addEventListener('click', function (e) {
        if (!nav.contains(e.target)) closeAll(null);
    });

    document.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape') return;
        var open = nav.querySelector('.is-submenu-open');
        if (!open) return;
        closeAll(null);
        var t = open.querySelector(':scope > .gh-submenu-toggle');
        if (t) t.focus();
    });
}
